(function(){
    'use strict';

/**
* @memberof app
* @ngdoc controller
* @name UsuariController
* @description
* This is main controller
**/ 

    angular
    .module('app')
    .controller('UsuariController', UsuariController);

    UsuariController.$inject = ["$timeout","debugService","userService","$location"];

    function UsuariController($timeout,debugService,userService,$location)
    {
    	var vm = this;
    	vm.user = userService;
        vm.textOk = "";
        vm.save= function(form)
        {
            if(form.$valid)
            {
                userService.configuracio(vm.user.info.username,vm.password_nova,vm.user.info.name,vm.user.info.surname,vm.user.info.email,vm.user.info.work,vm.user.info.state).then(function()
                    {
                        vm.textOk = "Usuari Guardat correctament.";
                        $timeout(function(){
                            vm.textOk = "";
                        },5000);

                    });
            }
        };

        vm.close= function()
        {
            userService.user().then(function()
            {
                $location.path("/");    
            });
            
        };

        vm.open= function()
        {
            
            jQuery('#usuari_iupload').find('input').trigger('click')

        };
    }

})();